import { createChat } from 'https://cdn.jsdelivr.net/npm/@n8n/chat/dist/chat.bundle.es.js';

createChat({
    webhookUrl: 'https://automacao.prezentinhos.com.br/webhook/007e4211-5951-489e-b7b9-bf103b62d8d8/chat',
    webhookConfig: {
        method: 'POST',
        headers: { }
    },
    mode: 'window',
    chatInputKey: 'chatInput',
    chatSessionKey: 'sessionId',
    loadPreviousSession: false,
    metadata: {
        temp_session_id: 'gfwueytb873btr23yr97123yb923h'
    },
    showWelcomeScreen: false,
    defaultLanguage: 'en',
    initialMessages: [
        'Eu sou o Cid, como posso ajudar?'
    ],
    i18n: {
        en: {
            title: 'Olá! 👋',
            subtitle: "Ajuda rápida para dúvidas",
            footer: '',
            getStarted: 'Nova conversa',
            inputPlaceholder: 'Escreva sua pergunta..',
        },
    },
    enableStreaming: false,
});
